import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiPhone, FiMail, FiGlobe, FiLinkedin, FiTwitter, FiInstagram } = FiIcons;

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const logoUrl = "https://img.gedhemedia.com/Logo_Primary_-_GedheMediaCom.png";

  const scrollToSection = (e, id) => {
    e.preventDefault();
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  const footerLinks = [
    { name: 'Home', id: 'home' },
    { name: 'Layanan', id: 'services' },
    { name: 'Keunggulan', id: 'solutions' },
    { name: 'Cara Kerja', id: 'process' }
  ];

  return (
    <footer id="contact" className="bg-[#0A192F] py-24 border-t border-white/10 relative overflow-hidden">
      <div className="absolute bottom-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#FF6B00] to-transparent opacity-50"></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-4 gap-16">
          <div className="lg:col-span-2 space-y-10">
            <div className="flex items-center">
              <img src={logoUrl} alt="GedheMedia" className="h-16 w-auto object-contain brightness-0 invert" />
            </div>
            <p className="text-gray-300 text-xl leading-relaxed max-w-md font-medium">
              Your Strategic Growth Partner. Kami membangun infrastruktur digital yang membantu bisnis lokal naik kelas.
            </p>
            <div className="flex space-x-6">
              {[FiLinkedin, FiTwitter, FiInstagram].map((Icon, i) => (
                <a 
                  key={i} 
                  href="#" 
                  className="w-14 h-14 bg-white/5 border border-white/10 rounded-2xl flex items-center justify-center text-white hover:bg-[#FF6B00] hover:border-[#FF6B00] transition-all duration-300 group"
                  aria-label="Social Media Link"
                >
                  <SafeIcon icon={Icon} className="text-2xl group-hover:scale-110 transition-transform" />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-white font-black mb-8 uppercase tracking-[0.2em] text-sm">Navigasi</h3>
            <ul className="space-y-5">
              {footerLinks.map((link) => (
                <li key={link.name}>
                  <a 
                    href={`#${link.id}`} 
                    onClick={(e) => scrollToSection(e, link.id)}
                    className="text-gray-400 hover:text-[#FF6B00] font-bold text-lg transition-colors flex items-center group"
                  >
                    <span className="w-0 group-hover:w-4 h-0.5 bg-[#FF6B00] mr-0 group-hover:mr-3 transition-all duration-300"></span>
                    {link.name}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="text-white font-black mb-8 uppercase tracking-[0.2em] text-sm">Hubungi Kami</h3>
            <div className="space-y-8">
              {[
                { icon: FiPhone, text: "0831-2841-8389", label: "WhatsApp" },
                { icon: FiMail, text: "hello@gedhemedia.com", label: "Email" },
                { icon: FiGlobe, text: "www.gedhemedia.com", label: "Website" }
              ].map((item, i) => (
                <div key={i} className="flex items-center space-x-5 group">
                  <div className="w-12 h-12 bg-[#FF6B00]/10 border border-[#FF6B00]/20 rounded-xl flex items-center justify-center text-[#FF6B00] group-hover:bg-[#FF6B00] group-hover:text-white transition-all">
                    <SafeIcon icon={item.icon} className="text-xl" />
                  </div>
                  <div>
                    <p className="text-gray-500 text-xs font-bold uppercase tracking-widest leading-none mb-1">{item.label}</p>
                    <span className="text-white font-bold text-lg">{item.text}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="border-t border-white/5 mt-24 pt-12 flex flex-col md:flex-row justify-between items-center text-center md:text-left">
          <p className="text-gray-500 font-bold text-sm">
            © {currentYear} GedheMedia. Pioneering Digital Excellence through Strategy.
          </p>
          <div className="flex space-x-8 mt-6 md:mt-0">
            <span className="text-gray-400 font-black text-[10px] tracking-[0.3em] uppercase">Built for Results</span>
            <span className="text-gray-400 font-black text-[10px] tracking-[0.3em] uppercase">Data Driven</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;